module.exports = __webpack_public_path__ + "static/media/content-05-m.b3683bca.png";